import Editor from '@monaco-editor/react';
import React from 'react';
import { Container } from 'ui/components/styled';

export const CodeEditor = ({ template, handleChange, preview, mode }) => {
  return (
    <Container>
      {mode === 'code' ? (
        <Editor height="90vh" defaultLanguage="html" value={template} onChange={handleChange} />
      ) : (
        <iframe height="100%" width="100%" srcDoc={preview} />
      )}
    </Container>
  );
};
